import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionStorageAdapter from "redux-persist/lib/storage/session";

import FormReducer from "./formReducer";
import CartReducer from "./cartReducer";
import AdminReducer from "../../containers/admin/console/redux/reducer";

const rootReducer = combineReducers({
    AdminReducer: persistReducer({ key: "AdminReducer", storage: sessionStorageAdapter }, AdminReducer.reducer),
    CartReducer: persistReducer({ key: "CartReducer", storage }, CartReducer.reducer),
});

export default rootReducer;
